export interface ITestDef {
    sections?: ISectionDef[]
    __meta?  : ITestMeta,
}
export interface ISectionDef {
    caption?      : string,
    hasCalculator?: boolean,
    hasFormulas?  : boolean,
    questions?    : string[],
    __meta?       : ISectionMeta
}

export interface ITestMeta {
    qs?: number, // how many questions are in the test
}
export interface ISectionMeta {
    qs?: number, // how many questions are in the current section
    qsPrec?: number, // how many questions appear 
    markLoc?: string, // % value indicating where the marker should be placed
}


export const SECTIONS_EN:ITestDef = {
    sections: [

        {caption:'test_section_1', hasCalculator: false, hasFormulas:true, questions:[
            'ocQKxGk5q3FFxBPq9Kdg',
            'iZclyXfgpWoy3pa8dqxm',
            'lJML7ab0S1Fv2vjpTnBY',
        ]},
        {caption:'test_section_2',hasCalculator: true, hasFormulas:true, questions:[
            'hbHqrwxUoJ83qkfxJp6a',
            'T0TNcv58zwNZ3vxEHEox',
            '2idaVTf7GR3jzcGSabVe',
            'E1Hwk2WIDqcvjOxyBa11',
            'ygIyHj7pIUhgkBhazBJb',
            'NhBYPu2p5khticOZ3WvF',
            '6RlqxjRY0eBL3O1gz43g',
            'xlwBysp4htH8JSxWpS70',
            'X9XiUGvxhPCGvrr1Tg3q',
            'MoEOS5Rr9MVOy2IxJCnk',
            'BzfDy2WgIXHjL2ChbEIM',
            'IXUD7Gmi8woPQ4ebkGMW',
            'RkCEj2qP01YMlTu0D4IC',
            'GnaDr73h7tQ4vjdpGXXO',
            'wgBhJ6qTRlC5nnUI9797',
            'rSZABv0A2p1oB83d1Rgg',
            '6gjFwZypGLuzpAJh49Pe',
            'WjyYGWo0EZG8Zeqs8ABt',
            'D29AD1Z64eDGLf6xRKLt',
            '4K4Dipw8Iy2PldPxCc7G',
        ]},
        {caption:'test_section_3',hasCalculator: false, hasFormulas:false, questions:[
            '2zEzs8UzXdUJalwmKPRe',
            'xrRKElsXSdwKSAlORAFb',
            'TsBjuSxGmNyoe2rkPyrw',
            'YOVYOsmzfqzW3EvJrWsZ',
            '5sy3s2LCSwaHWuzD8Cyn',
            '6nWnaLKde3jdZktQjZbX',
        ]},
    ]
}


export const SECTIONS_FR:ITestDef = {
    sections: [
        {hasCalculator: false, hasFormulas:true, questions:[
            'ocQKxGk5q3FFxBPq9Kdg_fr',
            'iZclyXfgpWoy3pa8dqxm_fr',
            'lJML7ab0S1Fv2vjpTnBY_fr',
        ]},
        {hasCalculator: true, hasFormulas:true, questions:[
            'hbHqrwxUoJ83qkfxJp6a_fr',
            'T0TNcv58zwNZ3vxEHEox_fr',
            '2idaVTf7GR3jzcGSabVe_fr',
            'E1Hwk2WIDqcvjOxyBa11_fr',
            'ygIyHj7pIUhgkBhazBJb_fr',
            'NhBYPu2p5khticOZ3WvF_fr',
            '6RlqxjRY0eBL3O1gz43g_fr',
            'xlwBysp4htH8JSxWpS70_fr',
            'X9XiUGvxhPCGvrr1Tg3q_fr',
            'MoEOS5Rr9MVOy2IxJCnk_fr',
            'BzfDy2WgIXHjL2ChbEIM_fr',
            'IXUD7Gmi8woPQ4ebkGMW_fr',
            'RkCEj2qP01YMlTu0D4IC_fr',
            'GnaDr73h7tQ4vjdpGXXO_fr',
            'wgBhJ6qTRlC5nnUI9797_fr',
            'rSZABv0A2p1oB83d1Rgg_fr',
            '6gjFwZypGLuzpAJh49Pe_fr',
            'WjyYGWo0EZG8Zeqs8ABt_fr',
            'D29AD1Z64eDGLf6xRKLt_fr',
            '4K4Dipw8Iy2PldPxCc7G_fr',
        ]},
        {hasCalculator: false, hasFormulas:false, questions:[
            '2zEzs8UzXdUJalwmKPRe_fr',
            'xrRKElsXSdwKSAlORAFb_fr',
            'TsBjuSxGmNyoe2rkPyrw_fr',
            'YOVYOsmzfqzW3EvJrWsZ_fr',
            '5sy3s2LCSwaHWuzD8Cyn_fr',
            '6nWnaLKde3jdZktQjZbX_fr',
        ]},
    ]
};



